module.exports = __webpack_public_path__ + "img/safe-logo-black.fc42ee4d.svg";